import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';
gsap.registerPlugin(ScrollTrigger);

const statisticModule = () => {

    const statistics = document.querySelectorAll('.js-statistic');

    statistics.forEach(statistic => {

        const delay = statistic.dataset.delay || 0;

        gsap.set(statistic, {
            filter: 'blur(10px)',
        });

        gsap.to(statistic, {
            opacity: 1,
            delay: delay,
            filter: 'blur(0px)',
            duration: 1,
            ease: 'power4.inOut',
            scrollTrigger: {
                trigger: statistic,
                start: 'top 95%',
                end: 'bottom bottom',
            },
        });

    });

}

export { statisticModule };